export default __webpack_public_path__ + "static/media/a7.fd72db38.svg";